import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataService } from '../services/data.service';
import { MaterialModule } from '../material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TimereportComponent } from './timereport.component';
import { TimereportAddComponent, AddTimereportDialogComponent } from './timereport-add/timereport-add.component';
import { TimereportListComponent, SendReportDialogComponent } from './timereport-list/timereport-list.component';
import { SharedModule } from '../shared/shared.module';
import { NgxWigModule } from 'ngx-wig';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgxWigModule
  ],
  declarations: [TimereportComponent, TimereportAddComponent, TimereportListComponent,
    AddTimereportDialogComponent, SendReportDialogComponent],
  entryComponents: [ AddTimereportDialogComponent, SendReportDialogComponent ],
  providers: [DataService]
})
export class TimereportModule { }



// WEBPACK FOOTER //
// ./src/app/timereport/timereport.module.ts